<template>
  <div class="video-container"> 
    <device-card host="video"></device-card>   
    
    <!-- 搜索区域 -->
    <div class="search-section">
        <van-search
            v-model="searchValue"
            placeholder="请输入型号关键词"
            shape="round"
            show-action
            @search="onSearch"
            @cancel="onCancel"
            class="search-box"
        >
            <template #action>
                <div @click="onSearch" class="search-action">搜索</div>
            </template>
        </van-search>
    </div>

    <!-- 视频列表 -->
    <div class="video-content">
        <!-- 结果统计 -->
        <div v-if="hasVideos" class="result-count">
            <van-icon name="video" class="count-icon" />
            共找到 {{ videolist.length }} 个安装视频
        </div>

        <!-- 视频列表 -->
        <div v-if="hasVideos" class="videos-container">
            <div 
                class="video-card" 
                v-for="item in videolist" 
                :key="item.RecID"
                @click="handleVideoClick(item.FileURL)"
            >
                <div class="video-header">
                    <van-icon name="video" class="video-icon" />
                    <div class="video-info">
                        <h4 class="video-title">{{ item.FileCaption }}</h4>
                        <p class="video-detail">{{ item.detail }}</p>
                    </div>
                    <van-icon name="arrow" class="arrow-icon" />
                </div>
            </div>
        </div>

        <!-- 空状态/初始状态 -->
        <div v-else class="empty-state">
            <van-empty description="请输入关键词搜索安装视频" image="search">
                <div class="search-tips">
                    <van-icon name="info" class="tip-icon" />
                    <p>可以输入关键词查询</p>
                </div>
            </van-empty>
        </div>
    </div>
  </div>
</template>
 
<script>
// @ is an alias to /src
import Vue from 'vue'
import 'vant/lib/icon/local.css';
import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);
import { Dialog } from 'vant';
import { Toast } from 'vant'
import global from '../../components/global.vue';
import DeviceCard from '../../components/devicecard.vue';

// 常量定义
const API_BASE_URL = 'https://t3.lenovoimage.com/api/Web2/productinfolist';
const MIN_SEARCH_LENGTH = 3;
const MESSAGES = {
  SEARCH_TOO_SHORT: '请输入至少3个字符进行搜索',
  NO_VIDEOS_FOUND: '未找到相关安装视频',
  SEARCH_FAILED: '搜索失败，请重试',
  VIDEO_TIP_TITLE: '温馨提示',
  VIDEO_TIP_MESSAGE: '点击查看安装视频',
  CONFIRM_TEXT: '点击查看'
};

export default {
   name: 'ShowArticle',
   components: {	
    DeviceCard 
   },
   data() {
        return {	
            devicesList: [],	
            keyword: '',           
            videolist: [],	
            productlines: [],
            searchValue: '',
            Driver: require("@/assets/driver2.png"),
            rows: 0,
            videoNumber: 0,
            SVGTransform: '',
            models: '',  
            pn: ''
        };
   },
   
   computed: {
        /**
         * 检查是否有视频数据
         */
        hasVideos() {
            return this.videolist && this.videolist.length > 0;
        }
   },
   
   created() {      
        this.initVideoData();
   },     
   
   mounted() {
        document.title = "安装视频";
   },
   
   methods: {	
        /**
         * 初始化视频数据
         */
        initVideoData() {
            this.devicesList = global.devicesList || [];
            if (this.devicesList.length > 0) {
                this.pn = this.devicesList[0].ProductCode || '';
                this.models = this.devicesList[0].Model || '';
                this.searchValue = this.models;
                this.keyword = this.models;
            }
            
            console.log(this.models, 'models');
            this.getVideoList();
        },
        
        /**
         * 搜索处理
         */
        onSearch() {
            const keyword = this.searchValue.trim();
            
            if (keyword.length < MIN_SEARCH_LENGTH) {
                Toast(MESSAGES.SEARCH_TOO_SHORT);
                return;
            }
            
            this.keyword = keyword;
            this.getVideoList();	  
        },
        
        /**
         * 取消搜索
         */
        onCancel() {
            this.searchValue = '';
            this.videolist = [];
        },
        
        /**
         * 获取视频列表
         */
        getVideoList() {
            const that = this;
            const params = `appid=svchome&keywords=${this.keyword}&sn=`;
            
            Vue.axios.get(`${API_BASE_URL}?${params}`)
                .then(function(response) {
                    that.handleVideoResponse(response);
                })
                .catch(function(error) {
                    that.handleVideoError(error);
                });
        },
        
        /**
         * 处理视频响应
         */
        handleVideoResponse(response) {
            console.log(response, 'response');
            if (response.data.Status === "0") {
                const data = response.data.Data;
                this.videolist = data.Table4 || [];
                this.videoNumber = this.videolist.length;
                console.log(this.videolist, 'videolist');
                
                if (this.videolist.length === 0) {
                    Toast(MESSAGES.NO_VIDEOS_FOUND);
                }
            } else {
                this.videolist = [];
                Toast(MESSAGES.NO_VIDEOS_FOUND);
            }
        },
        
        /**
         * 处理视频错误
         */
        handleVideoError(error) {
            console.log(error);
            this.videolist = [];
            Toast(MESSAGES.SEARCH_FAILED);
        },
        
        /**
         * 处理视频点击
         */
        handleVideoClick(url) {
            Dialog.confirm({
                title: MESSAGES.VIDEO_TIP_TITLE,
                message: MESSAGES.VIDEO_TIP_MESSAGE,
                confirmButtonText: MESSAGES.CONFIRM_TEXT,
                showCancelButton: false
            }).then(() => {
                this.navigateToVideo(url);
            });
        },
        
        /**
         * 跳转到视频页面
         */
        navigateToVideo(url) {
            this.$router.push({ 
                path: '/productinfo/openPDF',
                query: { pdfurl: url }
            });
        },
        
        /**
         * 返回首页
         */
        onClickLeft() {
            this.$router.push({ path: '/' });
        }
    }
}
</script>

<style scoped>
.video-container {
    background-color: #f7f8fa;
    min-height: 100vh;
}

.search-section {
    background-color: #ffffff;
    padding: 16px;
    border-bottom: 1px solid #f0f0f0;
}

.search-box {
    padding: 0;
    border-radius: 8px;
    overflow: hidden;
}

.search-action {
    color: #1989fa;
    font-size: 14px;
    padding: 0 8px;
}

.video-content {
    padding: 16px;
    background-color: #f7f8fa;
    min-height: 50vh;
}

.result-count {
    background-color: #e6f7ff;
    border: 1px solid #91d5ff;
    border-radius: 6px;
    padding: 12px;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #1890ff;   
}

.count-icon {
    margin-right: 8px;
    font-size: 16px;
}

.videos-container {
    display: flex;
    flex-direction: column;
    gap: 12px;
    height: 85vh;
    overflow-y: auto;
}

.video-card {
    background-color: #ffffff;
    border-radius: 12px;
    padding: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
    border: 1px solid #f0f0f0;
    transition: all 0.3s ease;
    cursor: pointer;
}

.video-card:active {
    background-color: #f5f5f5;
    transform: scale(0.98);
}

.video-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
}

.video-icon {
    color: #1989fa;
    font-size: 20px;
    margin-right: 12px;
    margin-top: 2px;
    flex-shrink: 0;
}

.video-info {
    flex: 1;
    min-width: 0;
}

.video-title {
    font-size: 15px;
    font-weight: bold;
    color: #323233;
    margin-bottom: 6px;
    line-height: 1.4;
    word-break: break-all;
}

.video-detail {
    font-size: 13px;
    color: #969799;
    margin: 0;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.arrow-icon {
    color: #969799;
    font-size: 14px;
    margin-left: 8px;
    flex-shrink: 0;
    margin-top: 2px;
}

.empty-state {
    padding: 40px 20px;
}

.search-tips {
    text-align: center;
    margin-top: 16px;
}

.tip-icon {
    color: #969799;
    font-size: 16px;
    margin-bottom: 8px;
}

.search-tips p {
    font-size: 14px;
    color: #969799;
    margin: 0;
}
</style>